// extracted by mini-css-extract-plugin
export default {"customers_details":"CustomersDetails_customers_details__3zMy4"};